module.exports = __webpack_public_path__ + "img/制御工学8_7.e29add76.png";